const accessRequestManager = {
  page: {
    title: "Access Requests",
    subtitle: "Review and approve access requests from researchers",
  },
  errors: {
    loadFailed: "Failed to load data",
    selectProjectRequired: "Please select a project",
    approveFailed: "Failed to approve request",
    rejectFailed: "Failed to reject request",
  },
  empty: {
    noRequests: "No pending access requests",
  },
  statusBadge: {
    awaitingEmailVerification: "Awaiting Email Verification",
    pendingReview: "Pending Review",
  },
  card: {
    email: "Email:",
    institution: "Institution:",
    projectInterest: "Project Interest:",
    requested: "Requested: {{date}}",
    newUser: "New User",
    mustVerifyEmail: "User must verify email first",
    previousRejections: "Previous Rejections:",
  },
  actions: {
    approve: "Approve",
    processing: "Processing...",
    reject: "Reject",
  },
  approveDialog: {
    title: "Approve Access Request",
    user: "User:",
    email: "Email:",
    assignToProject: "Assign to Project *",
    selectProjectPlaceholder: "Select a project...",
    role: "Role *",
    roleResearcher: "Researcher",
    rolePi: "Principal Investigator (PI)",
    notes: "Notes (Optional)",
    notesPlaceholder: "Optional approval notes...",
    approve: "Approve",
    approving: "Approving...",
    cancel: "Cancel",
  },
  rejectDialog: {
    title: "Reject Access Request",
    user: "User:",
    email: "Email:",
    reason: "Rejection Reason (Optional)",
    reasonPlaceholder: "Explain why this request is being rejected...",
    reject: "Reject",
    rejecting: "Rejecting...",
    cancel: "Cancel",
  },
};

export default accessRequestManager;
